import { render, staticRenderFns } from "./index.vue?vue&type=template&id=23acb36b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=23acb36b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23acb36b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\webproject\\haoyu\\wms-web\\WMS\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23acb36b')) {
      api.createRecord('23acb36b', component.options)
    } else {
      api.reload('23acb36b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=23acb36b&scoped=true&", function () {
      api.rerender('23acb36b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OPZPage/index.vue"
export default component.exports